import React from 'react';
import './bandeiras.css';

const RI_INICIO = 0x1F1E6;
const RI_FIM = 0x1F1FF;

function codigoBandeira(cp1, cp2) {
  return String.fromCharCode(0x41 + (cp1 - RI_INICIO)) + String.fromCharCode(0x41 + (cp2 - RI_INICIO));
}

function ehBandeira(a, b) {
  return a >= RI_INICIO && a <= RI_FIM && b >= RI_INICIO && b <= RI_FIM;
}

export function inserirBandeirasHtml(texto) {
  const chars = Array.from(String(texto || ''));
  let out = '';
  let i = 0;
  while (i < chars.length) {
    const a = chars[i].codePointAt(0);
    const b = i + 1 < chars.length ? chars[i + 1].codePointAt(0) : 0;
    if (ehBandeira(a, b)) {
      const code = codigoBandeira(a, b).toLowerCase();
      out += `<img class="ab-flag" src="https://flagcdn.com/20x15/${code}.png" alt="${code.toUpperCase()}" onerror="this.style.display='none'" />`;
      i += 2;
    } else {
      out += chars[i];
      i += 1;
    }
  }
  return out;
}

export function TextoComBandeiras({ texto }) {
  const chars = Array.from(String(texto || ''));
  const nodes = [];
  let buffer = '';
  let i = 0;
  let k = 0;
  while (i < chars.length) {
    const a = chars[i].codePointAt(0);
    const b = i + 1 < chars.length ? chars[i + 1].codePointAt(0) : 0;
    if (ehBandeira(a, b)) {
      if (buffer) {
        nodes.push(buffer);
        buffer = '';
      }
      const code = codigoBandeira(a, b).toLowerCase();
      nodes.push(
        <img
          key={`ab-flag-${k++}`}
          className="ab-flag"
          src={`https://flagcdn.com/20x15/${code}.png`}
          alt={code.toUpperCase()}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      );
      i += 2;
    } else {
      buffer += chars[i];
      i += 1;
    }
  }
  if (buffer) {
    nodes.push(buffer);
  }
  return nodes;
}

export function cortarTexto(texto, max) {
  const chars = Array.from(String(texto || ''));
  if (chars.length <= max) {
    return chars.join('');
  }
  return `${chars.slice(0, max).join('')} ...`;
}
